import { render, staticRenderFns } from "./booking-event-refuse-modal.vue?vue&type=template&id=1400571e&scoped=true&"
import script from "./booking-event-refuse-modal.vue?vue&type=script&lang=ts&"
export * from "./booking-event-refuse-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1400571e",
  null
  
)

export default component.exports